import type { Locale } from '@seek/melways-sites';
import { Box, Divider } from 'braid-design-system';
import type { FC } from 'react';

import type { ApplicationNoteV2 } from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import { HtmlContent } from 'src/libs/HtmlContent';

import Item from '../Item/Item';

interface Props {
  noteItem: ApplicationNoteV2;
  locale: Locale;
  onDelete: (attachmentItem: ApplicationNoteV2) => Promise<string>;
  canDelete: boolean;
}

export const NoteItem: FC<Props> = ({
  noteItem,
  locale,
  onDelete,
  canDelete,
}) => (
  <>
    <Box data-testid="notes" style={{ paddingBottom: '6px' }}>
      <Item
        type="note"
        user={`${noteItem?.createdUserFirstname} ${noteItem?.createdUserLastname}`}
        date={noteItem?.createdDate}
        canDelete={canDelete}
        onDelete={() => onDelete(noteItem!)}
        locale={locale}
      >
        <Box>
          <HtmlContent
            content={noteItem?.content ?? ''}
            isSecondary={false}
            size="small"
            space="xsmall"
          />
        </Box>
      </Item>
    </Box>
    <Divider />
  </>
);
